var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProposalIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 220 275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#73b61d;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono Propuesta de Proyecto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cabecera"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 220,
    height: 275
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184,72.18,151.79,40H56V158.85a39.33,39.33,0,1,0,36.61,58.53H184ZM153.15,47.87,176.1,70.82H153.15ZM58.28,163.41A34.54,34.54,0,0,1,81.12,172l-9.84,9.85a20.81,20.81,0,0,0-33.68,14h-14a34.76,34.76,0,0,1,34.63-32.39ZM56,214.14a16.19,16.19,0,0,1,0-32Zm4.63,0v-32a16.19,16.19,0,0,1,0,32ZM23.65,200.43h14A20.78,20.78,0,0,0,56,218.8v13.95a34.77,34.77,0,0,1-32.32-32.32Zm37,32.32V218.8a20.81,20.81,0,0,0,13.95-33.68l9.85-9.84a34.69,34.69,0,0,1-23.8,57.47Zm34.2-20a39.34,39.34,0,0,0-34.21-53.9V44.6h87.93V75.45h30.85v137.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.79,
    y: 64.66,
    width: 61.71,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 76.79,
    y: 77,
    width: 49.36,
    height: 4.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.4,107.85H139.26V151h-7.71V95.51H108.41V151H100.7V120.19H77.56v35.48H162.4ZM96.07,151H82.19V124.82H96.07Zm17-50.9h13.88V151H113ZM157.78,151H143.89V112.48h13.89Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 101.47,
    y: 169.56,
    width: 61.7,
    height: 4.63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 113.81,
    y: 181.9,
    width: 49.36,
    height: 4.63
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProposalIcon);
export default __webpack_public_path__ + "static/media/proposalIcon.16cdcfe15cb10d4920b7443c57bc6036.svg";
export { ForwardRef as ReactComponent };